import script from "./HospitalApply.vue?vue&type=script&setup=true&lang=ts"
export * from "./HospitalApply.vue?vue&type=script&setup=true&lang=ts"

import "./HospitalApply.vue?vue&type=style&index=0&id=acf3eaf0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acf3eaf0"]])

export default __exports__